import { render } from "./CreateAppModal.vue?vue&type=template&id=5b0727b2&scoped=true"
import script from "./CreateAppModal.vue?vue&type=script&lang=ts"
export * from "./CreateAppModal.vue?vue&type=script&lang=ts"

import "./CreateAppModal.vue?vue&type=style&index=0&id=5b0727b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b0727b2"

export default script